import revive_payload_client_4sVQNw7RlN from "/home/runner/work/remak-frontend/remak-frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/remak-frontend/remak-frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/remak-frontend/remak-frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/runner/work/remak-frontend/remak-frontend/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/runner/work/remak-frontend/remak-frontend/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/runner/work/remak-frontend/remak-frontend/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/remak-frontend/remak-frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tMGwffvjBc from "/home/runner/work/remak-frontend/remak-frontend/node_modules/@formkit/auto-animate/nuxt/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/remak-frontend/remak-frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/remak-frontend/remak-frontend/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_1UohGbtF8v from "/home/runner/work/remak-frontend/remak-frontend/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import sentry_client_shVUlIjFLk from "/home/runner/work/remak-frontend/remak-frontend/plugins/sentry.client.ts";
import vue_dompurify_html_ER8SW1XOdk from "/home/runner/work/remak-frontend/remak-frontend/plugins/vue-dompurify-html.ts";
import vue_masonry_wall_13R6vu58Yn from "/home/runner/work/remak-frontend/remak-frontend/plugins/vue-masonry-wall.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tMGwffvjBc,
  chunk_reload_client_UciE0i6zes,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_1UohGbtF8v,
  sentry_client_shVUlIjFLk,
  vue_dompurify_html_ER8SW1XOdk,
  vue_masonry_wall_13R6vu58Yn
]